import { BetResponseCode } from '@pascal/pascal-core';

export const decidedCurrentValue = (
  condition,
  value,
  finishedValue,
  showNotification,
  responseCode
) => {
  const currentValue = condition ? value : finishedValue;
  if (currentValue === finishedValue && showNotification && responseCode) {
    showNotification({ responseCode });
  }
  return condition ? value : finishedValue;
};

export const checkDoBetModel = (limits, userBalance, amount) => {
  let generatedBetResponseCode;
  if (Number(amount) < limits.minBet) {
    generatedBetResponseCode = BetResponseCode.InValidMinBet;
  } else if (Number(amount) > limits.maxBet) {
    generatedBetResponseCode = BetResponseCode.InValidMaxBet;
  }
  // else if (Number(amount) > userBalance && isDemo) {
  //   generatedBetResponseCode = BetResponseCode.InsufficientFunds;
  // }
  return generatedBetResponseCode;
};

export const betAmountValidator = (betAmount, limits) => {
  let validatedBetAmount = null;
  let errorMessageCode = null;
  const { maxBet, minBet } = limits;

  switch (true) {
    case !maxBet || (betAmount > maxBet && maxBet < minBet): {
      errorMessageCode = BetResponseCode.InsufficientFunds;
      validatedBetAmount = minBet;
      break;
    }
    case Number.isNaN(betAmount) || betAmount <= minBet: {
      if (betAmount < minBet) {
        errorMessageCode = BetResponseCode.InValidMinBet;
      }
      validatedBetAmount = minBet;
      break;
    }
    case betAmount > maxBet: {
      errorMessageCode = BetResponseCode.InValidMaxBet;

      validatedBetAmount = maxBet;
      break;
    }
    default:
      validatedBetAmount = betAmount;
  }

  return { validatedBetAmount, errorMessageCode };
};
